import React, { PropsWithChildren } from "react";

import css from "./index.module.scss";

export type Props = {
  className?: string;
};

export const Card = ({ className, children }: PropsWithChildren<Props>) => {
  return <div className={[css.card, className].join(" ")}>{children}</div>;
};
